import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'test2-component',
  styleUrl: 'test2-component.css',
  shadow: true,
})
export class Test2Component {

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }

}
